export const SET_CASE_ID = 'SET_CASE_ID';

export const GET_CASE_ID = "GET_CASE_ID";